const bgColorMap: Record<string, string> = {
  red: 'bg-[#DE4545]',
  blue: 'bg-blue-500',
  green: 'bg-green-500',
  gray: 'bg-gray-500',
  orange: 'bg-orange-500',
};

type TagBadgeProps = {
  label: string;
  color?: keyof typeof bgColorMap;
};

export default function TagBadge({ label, color = 'red' }: TagBadgeProps) {
  return (
    <span
      className={`inline-block text-mob-12 sm:text-tab-11 lg:text-web-14 uppercase tracking-wide text-white px-mob-16 sm:px-tab-16 lg:px-web-16 py-mob-4 sm:py-tab-4 lg:py-web-4 rounded-full ${
        bgColorMap[color]
      }`}
    >
      {label}
    </span>
  );
}
